console.log('**** MAIN ****')
import { createApp } from 'vue'

import { createPinia } from 'pinia'
import i18n from '@/i18n/i18n-setup.js'
import vuetify from '@/plugins/vuetify.js'

import App from './App.vue'
import router from './router'
import dayjs from '@/plugins/dayjs'

import { Buffer } from 'node:buffer'

import '@/assets/css/main.css'
import '@mdi/font/css/materialdesignicons.css'

// import { Ckeditor } from '@ckeditor/ckeditor5-vue'
// https://ckeditor.com/docs/ckeditor5/latest/installation/integrations/vuejs-v3.html

import I18nDiv from '@/components/i18n/I18nDiv.vue'
import I18nSpan from '@/components/i18n/I18nSpan.vue'
import I18nTextField from '@/components/i18n/I18nTextField.vue'
import I18nTextarea from '@/components/i18n/I18nTextarea.vue'
import I18nSwitch from '@/components/i18n/I18nSwitch.vue'
import I18nSelect from '@/components/i18n/I18nSelect.vue'

import WaitData from '@/components/WaitData.vue'

// import { updateSW } from 'virtual:pwa-register'

window.Buffer = Buffer

const app = createApp(App)

const pinia = createPinia()

import Toast from 'vue-toastification'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'

const toastOptions = {
  timeout: 6000,
  maxToasts: 10,
  newestOnTop: true,
  showCloseButtonOnHover: true,
  position: 'top-center'
}

app.config.globalProperties.$date = dayjs

app.component('I18nDiv', I18nDiv)
app.component('I18nSpan', I18nSpan)
app.component('I18nTextField', I18nTextField)
app.component('I18nTextarea', I18nTextarea)
app.component('I18nSwitch', I18nSwitch)
app.component('I18nSelect', I18nSelect)

app.component('WaitData', WaitData)

// app.use(updateSW)
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(vuetify)
app.use(Toast, toastOptions)
// app.use(Ckeditor)
// app.use(i18nToast)

app.mount('#app')
